import React from 'react'
import HealthcareBanner from '../Healthcare/HealthcareBanner';
import HealthcareExcellence from '../Healthcare/HealthcareExcellence';
import HealthcareFacility from '../Healthcare/HealthcareFacility';
import HealthcareCounter from '../Healthcare/HealthcareCounter';
import HealthcareSmart from '../Healthcare/HealthcareSmart';
import HealthcarePremise from '../Healthcare/HealthcarePremise';
import HealthcareBrand from '../Healthcare/HealthcareBrand';
import HealthcareBusinesse from '../Healthcare/HealthcareBusinesse';
import HealthcareFaq from '../Healthcare/HealthcareFaq';
import HomeProducts from '../../home/HomeProducts';

export default function Hospitality({ initialData }) {



  const Banner = {
    buttonText: "Global Markets",
    buttonLink: "/markets",
    title: "Premium Laundry Services for Hotels",
    description: "Transform guest satisfaction and operational costs with in-house laundry systems designed for hospitality excellence, delivering pristine linens, predictable turnaround, and complete quality control without vendor dependencies, while ensuring uninterrupted service during peak seasons and maintaining the highest standards of hygiene and efficiency.",
    image: "/assets/images/hospital-banner1.webp"
  };

  const excellenceData = {
    subtitle: "Hospitality-First Engineering",
    title: "Your Linen Quality Defines Your Brand",
    description1: "Guest reviews mention linen quality in 78% of five-star ratings. That towel softness, sheet crispness, and fresh scent? They're not laundry details, they're brand promises. Supershine engineers systems that protect those promises through every wash cycle.",
    description2: "Whether you're running a 50-room boutique or a 500-room resort, we build laundry operations that match your guest standards. No more waiting on vendors. No more inconsistent quality. Just complete control over the details that turn first-time guests into regulars.",
    buttonText: "Talk to Our Experts",
    buttonLink: "/healthcare"
  };


  const facilityData = {
    title: "Why Supershine  <br/> For Your Hospitality Business?",
    items: [
      {
        icon: "/assets/images/hospitality-icon1.webp",
        heading: "Guest-Ready Presentation",
        description: " Achieves luxury hotel standards for sheet crispness, towel fluffiness, and spotless presentation that guests notice immediately."
      },
      {
        icon: "/assets/images/hospitality-icon2.webp",
        heading: "Peak Season Performance",
        description: "Handles occupancy surges, wedding weekends, and conference blocks without quality drops or turnaround delays compromising service."
      },
      {
        icon: "/assets/images/hospitality-icon3.webp",
        heading: "Cost Predictability",
        description: "Eliminates unpredictable vendor pricing, per-piece fees, and seasonal rate hikes, delivering fixed operational costs and better budget control."
      },

      {
        icon: "/assets/images/hospitality-icon4.webp",
        heading: "Extended Linen Life",
        description: "Gentle processing reduces fabric stress, cutting replacement frequency by 40% and protecting your textile investment significantly."
      },

      {
        icon: "/assets/images/hospitality-icon5.webp",
        heading: "Instant Availability",
        description: "Processes rush requests, handles unexpected needs, and responds to housekeeping demands without waiting for vendor pickup schedules."
      },


      {
        icon: "/assets/images/hospitality-icon6.webp",
        heading: "Labor Efficiency",
        description: "Automated systems reduce manual handling, improve workflow speed, and allow smaller teams to manage higher volumes effectively."
      }
    ]
  };


  const HeathCareCounter = {
    title: "Trusted By The Hospitality Industry",
    stats: [
      {
        end: 400,
        suffix: "+",
        text: " Properties Operate <br/> Supershine Systems",
      },
      {
        end: 99,
        suffix: "%",
        text: " Rooms Receive Linens <br/> On-Schedule",
      },
      {
        end: 500,
        suffix: "+",
        text: " Loads Processed Per <br/>  Day Capacity",
      },
      {
        prefix: "",
        end: 38,
        suffix: "%",
        text: " Quicker Than <br/> Outsourced Processing",
      },
    ],
  };

  const Fashionsmart = {
    extraClass: "",
    heading: `Stop Paying Vendors. Start Controlling Costs.`,
    description: "Calculate your savings: most hotels eliminate outsourcing costs entirely within three years while gaining quality consistency that improves guest scores. Our systems pay for themselves through eliminated vendor fees, reduced linen replacement, and operational efficiency gains.",
    buttonText: "Learn More",
    buttonLink: "/about",
    altText: "Smart"
  };


  const PremiseData = {
    image: "/assets/images/laundry-left-image.webp",
    title: "What On-Premise Laundry Actually Delivers",
    subtitle: "The Business Case for In-House Control:",
    reasons: [
      "Stop gambling on vendor quality, guarantee linen standards that protect your property's reputation and positive review scores consistently. ",
      "End turnaround delays; process linens on your schedule, respond instantly to housekeeping needs, and never wait for pickup windows again.",
      "Cut long-term costs dramatically, eliminate per-piece charges, delivery fees, emergency rush charges, and unpredictable vendor rate increases completely.",
      "Protect linen investment better; gentle, controlled processing extends textile life 40% longer, reducing annual replacement budgets substantially year-over-year.",
      "Receive complete operational support from custom space planning and staff training to ongoing maintenance and emergency response within hours."
    ],
    buttonText: "Design Your Hotel Solution",
    buttonLink: "/contact"
  };


  const healthcareBrandData = {
    title: "",
    logos: [
      { image: "/assets/images/hospital-logos6.webp", title: "Brand 1" },
      { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
      { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
      { image: "/assets/images/hospital-new-img1.webp", title: "Brand 4" },
      { image: "/assets/images/hospital-new-img2.webp", title: "Brand 5" },
      { image: "/assets/images/hospital-new-img3.webp", title: "Brand 6" },
      { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
      { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
    ]
  };



  const businessData = {
    title: "Trusted by Businesses,<br />Driven by Excellence.",
    description:
      "Chosen by businesses for dependable service, superior quality, and a commitment to excellence in commercial laundry solutions.",
    testimonials: [
      {
        rating: 5,
        text:
          "“Managing linen across five properties used to mean constant firefighting. Supershine's equipment changed our entire workflow; turnaround times dropped, fabric quality improved, and our housekeeping teams finally have a system they can rely on. Guests notice the difference too, especially in our premium rooms where bedding and towels need to feel consistently fresh. It has made scaling to new properties far less stressful.”",
        client: "Anjali Mathur, Group Operations Manager, Hospitality Chain",
      },
      {
        rating: 5,
        text:
          "“During peak season, our old machines simply couldn't keep up and breakdowns were costing us bookings. Since switching to Supershine, we've had zero unplanned downtime across three months of full occupancy. The technicians who installed the equipment also trained our staff thoroughly, so we're not dependent on external support for routine issues. That reliability alone has been worth the investment.”",
        client: "Rohan Kapoor, General Manager, Resort Property",
      },
      {
        rating: 5,
        text:
          "“Sustainability is a big part of our brand promise to guests, and our laundry operations were working against that. Supershine's machines use noticeably less water and energy per cycle while still delivering the finish our linen standards require. We've been able to highlight this in our guest communications, which has genuinely helped with bookings from eco-conscious travellers.”",
        client: "Natasha Pillai, Sustainability Lead, Boutique Hotel Group",
      },
    ],
  };


  const productData = {
    subtitle: "Recommended Products",
    title: "Elevate Hotel Laundry Standards <br/> with Advanced Solutions",
  
  };

  const faqData = {
    title: "FAQs",
    description: "Straight answers about bringing laundry in-house for your property.",
    buttonText: "Talk to an expert",
    buttonLink: "/contact",
    faqs: [
      {
        question: "How quickly does on-premise laundry pay for itself?",
        answer:
          "Typical payback is 2.5-3 years through eliminated vendor fees, reduced linen replacement, and efficiency gains. Properties processing 300+ rooms daily often see ROI under 2 years. We'll calculate exact projections based on your current outsourcing costs.",
      },
      {
        question: "Will in-house laundry match our current quality standards?",
        answer:
          "Most hotels report improved consistency versus vendors. Our systems let you control exact temperatures, chemical ratios, and cycle times, eliminating the quality variation that comes from shared vendor facilities processing multiple properties simultaneously.",
      },
      {
        question: "What space and utilities does hotel laundry require?",
        answer:
          "Space needs vary by volume: 50-100 rooms need roughly 400-600 sq ft; 200+ rooms need 1000-1500 sq ft. We design systems for your existing utility infrastructure or specify needed upgrades during planning, most hotels have adequate capacity.",
      },

      {
        question: " How many staff members will we need for operations?",
        answer:
          "Staffing depends on volume and operating hours. A 150-room property typically needs 2-3 FTEs for full-time laundry. Our automated systems reduce labor versus manual processing, and many hotels redeploy existing housekeeping staff rather than hiring new positions.",
      },

      {
        question: " What happens when equipment needs service or breaks down?",
        answer:
          "We provide 24/7 technical support with most issues resolved remotely. For on-site needs, our technicians respond within 24 hours in metro areas. Systems include redundancy for critical components, and preventive maintenance schedules minimize unexpected downtime significantly.",
      },

      {
        question: "Can we start small and expand capacity later?",
        answer:
          "Absolutely. Many properties start with core washing capacity and add finishing equipment, additional machines, or separate zones as occupancy grows. Our modular approach protects initial investment while supporting expansion without replacing existing infrastructure completely.",
      },
    ],
  };

  
  const bannerData = {
    head: "Home",
    breadcrumb: [
      {
        slug: "/hospitality-laundry-washing-machine-system",
        name: "Hospital"
      }
    ]

  }



  return (
    <>

      <HealthcareBanner data={Banner}  breadcrumb={bannerData.breadcrumb}/>
      <HealthcareExcellence data={excellenceData} />
      <HealthcareFacility data={facilityData} />
      <HealthcareCounter data={HeathCareCounter} />
      <HealthcareSmart data={Fashionsmart} />
      <HealthcarePremise data={PremiseData} />
      <HealthcareBrand data={healthcareBrandData} />
      <HealthcareBusinesse data={businessData} />
      <HomeProducts data={productData} extraClass="healthcare-product" initialData={initialData}  />
      <HealthcareFaq data={faqData} />
    </>
  )
}



